// src/jsx/components/common/ProtectedRoute.jsx
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { fetchMyPermissionsThunk } from "../../../store/slices/permissionSlice";

function normKey(k) {
  return String(k || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/-/g, "_");
}

export default function ProtectedRoute({ moduleKey, children }) {
  const dispatch = useDispatch();

  const token = useSelector((s) => s.auth.token);
  const role = String(useSelector((s) => s.auth.user?.role) || "").toLowerCase();
  const isSuperadmin = role === "superadmin";

  const panIds = useSelector((s) => s.tenant.pan_ids);
  const panActive = useSelector((s) => s.tenant.pan_id_active);

  const { map, loaded, loading } = useSelector((s) => s.permissions);

  const hasTenant = isSuperadmin ? (panIds.length > 0 || panActive > 0) : true;

  // ✅ fetch permissions once when ready
  useEffect(() => {
    if (!token) return;
    if (!hasTenant) return;
    if (loaded || loading) return; // ✅ prevent spam
    dispatch(fetchMyPermissionsThunk());
  }, [token, hasTenant, loaded, loading, dispatch]);

  if (!token) return <Navigate to="/login" replace />;

  // ✅ superadmin: don't show "Select Panchayath", show loading (tenant will auto-set)
  if (!hasTenant) return <div style={{ padding: 16 }}>Loading…</div>;

  if (loading || !loaded) return <div style={{ padding: 16 }}>Loading permissions…</div>;

  const key = normKey(moduleKey);
  const canView = map?.[key]?.can_view;

  if (!canView) return <Navigate to="/page-error-403" replace />;

  return children;
}
